module.exports = __webpack_public_path__ + "svg/flags/Saint Martin (French part).svg";